import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import ReportComponent from "../../components/report/ReportComponent";
import Loading from "../../../components/isLoading";
import { fetchReportData } from "../../../redux/reports";
import { Edit, Publish } from "@material-ui/icons";
import { DeleteForever } from "@mui/icons-material";
import DeleteModel from "../DeleteModel";
import ConfirmModel from "../ConfirmModel";
import { DELETE_REPORT } from "../../../redux/reports/types";

const ReportContainer = (props) => {
  const { id } = props;
  const [state, setState] = useState({
    openDeleteMessage: false,
    openConfirmation: false,
  });
  const navigate = useNavigate();

  const reportData = useSelector((state) => state.reportGlobalStore);
  const deleteStore = useSelector((store) => store.deleteReportGlobalStore);
  const dispatch = useDispatch();

  useEffect(() => {
    if (id) {
      dispatch(fetchReportData(id));
    }
  }, []);

  const handleOnEdit = () => navigate("edit");

  const handleOpenCloseConfirmModel = (condition) =>
    setState((prevState) => ({ ...prevState, openConfirmation: condition }));

  const handleOpenCloseDeleteModel = (condition) =>
    setState((prevState) => ({ ...prevState, openDeleteMessage: condition }));

  const isUnpublish = reportData.data?.status === "published";
  const crumps = [
    {
      title: "Reports",
      path: "/reports",
    },
  ];
  const actions = [
    {
      onClick: handleOnEdit,
      text: "Edit Report",
      icon: <Edit fontSize="small" />,
    },
    {
      onClick: () => handleOpenCloseConfirmModel(true),
      text: isUnpublish ? "Unpublish Report" : "Publish Report",
      icon: <Publish fontSize="small" />,
    },
    {
      onClick: () => handleOpenCloseDeleteModel(true),
      text: "Delete Report",
      icon: <DeleteForever fontSize="small" />,
    },
  ];
  return reportData.loading ? (
    <Loading />
  ) : (
    <div>
      <DeleteModel
        isOpen={state.openDeleteMessage}
        isFor="Reports"
        handleCloseModel={() => handleOpenCloseDeleteModel(false)}
        itemId={id}
        store={deleteStore}
        action={DELETE_REPORT}
      />
      <ConfirmModel
        isOpen={state.openConfirmation}
        isFor="Reports"
        handleCloseModel={handleOpenCloseConfirmModel}
        itemId={id}
        isUnpublish={isUnpublish}
      />
      <ReportComponent
        reportDetails={reportData.data || {}}
        crumps={crumps}
        actions={actions}
      />
    </div>
  );
};

export default ReportContainer;
